import fb from '@/services/firebase.js'
import router from '../../router'

export const namespaced = true

export const state = {
  loading: false,
  unfinished: ''
}

export const mutations = {
  SET_LOADING(state, value) {
    state.loading = value
  },
  SET_UNFINISHED(state, value) {
    state.unfinished = value
  }
}

export const actions = {
  startArrangement({ commit }, uniqueId) {
    commit('SET_LOADING', true)
    fb.auth.onAuthStateChanged(user => {
      var placing_order = {
        created_at: Date.now(),
        finished_at: null
      }
      fb.db
        .collection('orders')
        .doc(uniqueId)
        .set({ initiator_uid: user.uid, placing_order })
        .then(() => {
          router.push({
            name: 'Arrange',
            params: { id: uniqueId }
          })
        })
      commit('SET_LOADING', false)
    })
  },
  addWho({ commit }, details) {
    commit('SET_LOADING', true)
    fb.db.collection('orders').doc(details.id).update({ initiator: details.who })
    commit('SET_LOADING', false)
  },
  hasUnfinishedOrder({ commit }) {
    fb.auth.onAuthStateChanged(user => {
      fb.db
        .collection('orders')
        .where('initiator_uid', '==', user.uid)
        .onSnapshot(docs => {
          if (docs.empty == false) {
            docs.forEach(doc => {
              if (doc.data().placing_order.finished_at == null) {
                commit('SET_UNFINISHED', doc.id)
              } else {
                commit('SET_UNFINISHED', '')
              }
            })
          } else {
            commit('SET_UNFINISHED', '')
          }
        })
    })
  },
  deleteArrangement({ commit }, order_id) {
    fb.db
      .collection('orders')
      .doc(order_id)
      .delete()
      .then(() => {
        commit('SET_UNFINISHED', '')
        return true
      })
  }
}

export const getters = {}
